import { default_header, default_header_example } from '../defaultData';
import { apiParamDesc, apiDocDesc } from '../docHelpers';

const getV10APIs = (userInfo) => {
  return [
    {
      title: '세트상품 조회',
      url: '/doc/세트상품 조회',
      data: [
        {
          version: 'v1.0',
          url: '/stock/sets',
          method: 'POST',
          desc: apiDocDesc({ items: ['세트상품목록을 조회합니다.'] }),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'start',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '조회할 시작 카운트', defaultValue: '0' }),
            },
            {
              title: 'limit',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '조회할 갯수', defaultValue: '100' }),
            },
            {
              title: 'orderbyType',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '정렬타입', defaultValue: 'DESC', allowedValues: ['ASC', 'DESC'] }),
            },
            {
              title: 'orderbyColumn',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '정렬대상',
                defaultValue: 'wdate',
                allowedValues: [
                  ['wdate', '<strong>등록일</strong>'],
                  ['set_no', '<strong>세트코드</strong>'],
                  ['set_status', '<strong>상태</strong>'],
                  ['mdate', '<strong>수정일</strong>'],
                  ['link_yn', '<strong>연동상품</strong>'],
                  ['link_ord_yn', '<strong>연동주문</strong>'],
                ],
              }),
            },
            {
              title: 'date_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '날짜검색대상',
                defaultValue: 'wdate',
                allowedValues: [['wdate', '<strong>등록일</strong>'], ['mdate', '<strong>수정일</strong>']],
              }),
            },
            {
              title: 'sdate',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색시작일',
                sub: ['(YYYY-MM-DD)', '<strong><code>미입력시 기본 30일로 조회됩니다.</code></strong>'],
              }),
            },
            {
              title: 'edate',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '검색종료일', sub: '(YYYY-MM-DD)' }),
            },
            {
              title: 'search_key',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색 키',
                sub: 'Allowd values',
                allowedValues: [
                  ['set_no', '<strong>세트번호</strong>'],
                  ['set_cd', '<strong>세트코드</strong>'],
                  ['set_name', '<strong>세트상품명</strong>'],
                  ['sku_cd', '<strong>SKU코드</strong>'],
                  ['stock_cd', '<strong>재고관리코드</strong>'],
                  ['prod_name', '<strong>SKU상품명</strong>'],
                  ['memo', '<strong>메모</strong>'],
                ],
                notes: ['<code>값을 넣지않는경우 전체검색됩니다.</code>'],
              }),
            },
            {
              title: 'search_word',
              required: '',
              type: 'String',
              desc: '검색어',
            },
            {
              title: 'search_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색타입',
                defaultValue: 'partial',
                allowedValues: [['exact', '<strong>완전일치</strong>'], ['partial', '<strong>부분일치</strong>']],
              }),
            },
            {
              title: 'depot_no',
              required: '',
              type: 'Number',
              desc: '배송처 번호',
            },
            {
              title: 'set_status',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '세트상태', allowedValues: ['정상', '재고부족', '사용불가', '품절'] }),
            },
          ],
          body_example: {
            start: 0,
            limit: 100,
            orderbyColumn: 'wdate',
            orderbyType: 'DESC',
            search_key: '',
            search_word: '테스트',
            search_type: 'partial',
            date_type: 'wdate',
            sdate: '2020-12-25',
            edate: '2021-03-23',
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Array',
              desc: '결과',
            },
            {
              title: 'set_no',
              required: 'O',
              type: 'Number(10)',
              desc: '세트번호(고유값)',
              indent: 1,
            },
            {
              title: 'sol_no',
              required: 'O',
              type: 'Number(8)',
              desc: '솔루션번호',
              indent: 1,
            },
            {
              title: 'depot_no',
              required: 'O',
              type: 'Number(8)',
              desc: '배송처번호',
              indent: 1,
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String(19)',
              desc: '세트 등록일',
              indent: 1,
            },
            {
              title: 'mdate',
              required: 'O',
              type: 'String(19)',
              desc: '세트 수정일',
              indent: 1,
            },
            {
              title: 'set_cd',
              required: 'O',
              type: 'String(40)',
              desc: '세트 코드',
              indent: 1,
            },
            {
              title: 'set_status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '세트상태',
                sub: '(정상, 재고부족, 사용불가, 품절)',
                allowedValues: ['정상', '재고부족', '사용불가', '품절'],
              }),
              indent: 1,
            },
            {
              title: 'set_name',
              required: 'O',
              type: 'String(200)',
              desc: '세트이름',
              indent: 1,
            },
            {
              title: 'sale_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({ title: '세트판매가', sub: '(data type: Decimal(12,2))' }),
              indent: 1,
            },
            {
              title: 'use_sale_cnt_limit_yn',
              required: 'O',
              type: 'Number(1)',
              desc: apiParamDesc({ title: '세트판매수량 사용여부', sub: '(1:사용함, 0:사용안함)' }),
              indent: 1,
            },
            {
              title: 'sale_cnt_limit',
              required: 'O',
              type: 'Number(10)',
              desc: '세트판매수량',
              indent: 1,
            },
            {
              title: 'main_prod_no',
              required: 'O',
              type: 'Number(10)',
              desc: '대표SKU상품번호',
              indent: 1,
            },
            {
              title: 'main_sku_cd',
              required: 'O',
              type: 'String',
              desc: '대표SKU상품코드',
              indent: 1,
            },
            {
              title: 'delivery_vendor_name',
              required: 'O',
              type: 'String(45)',
              desc: '배송처명',
              indent: 1,
            },
            {
              title: 'out_leadtime',
              required: '',
              type: 'Number',
              desc: '출고 리드타임',
              indent: 1,
            },
            {
              title: 'set_prod_cnt',
              required: 'O',
              type: 'Number',
              desc: '세트에 할당된 SKU상품 수',
              indent: 1,
            },
            {
              title: 'set_sku_cds',
              required: 'O',
              type: 'String',
              desc: '세트에 할당된 SKU상품 sku코드',
              indent: 1,
            },
            {
              title: 'set_pack_units',
              required: 'O',
              type: 'String',
              desc: '세트에 할당된 SKU상품 출고수량',
              indent: 1,
            },
            {
              title: 'set_cost_prices',
              required: 'O',
              type: 'String',
              desc: '세트에 할당된 SKU상품 세트원가',
              indent: 1,
            },
            {
              title: 'set_supply_prices',
              required: 'O',
              type: 'String',
              desc: '세트에 할당된 SKU상품 세트공급가',
              indent: 1,
            },
            {
              title: 'set_prod_names',
              required: 'O',
              type: 'String',
              desc: '세트에 할당된 SKU상품 상품명',
              indent: 1,
            },
            ...(userInfo.sol_ser?.includes('cal_state_per_prod') ? [
              {
                title: 'set_sales_per_list',
                required: 'O',
                type: 'String',
                desc: '세트에 할당된 SKU상품 금액비중',
                indent: 1,
              }
            ] : []),
            {
              title: 'link_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '매칭된 온라인상품 수',
              indent: 1,
            },
            {
              title: 'link_ord_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '매칭된 주문 수',
              indent: 1,
            },
            {
              title: 'memo',
              required: 'O',
              type: 'Array',
              desc: '세트에 등록된 메모정보',
              indent: 1,
            },
            {
              title: 'set_no',
              required: 'O',
              type: 'Number(10)',
              desc: '세트번호(고유값)',
              indent: 2,
            },
            {
              title: 'memo_no',
              required: 'O',
              type: 'Number(10)',
              desc: '메모번호(고유값)',
              indent: 2,
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String(19)',
              desc: '메모등록일',
              indent: 2,
            },
            {
              title: 'mdate',
              required: 'O',
              type: 'String(19)',
              desc: '메모수정일',
              indent: 2,
            },
            {
              title: 'memo_Status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '메모상태', allowedValues: ['등록', '완료'] }),
              indent: 2,
            },
            {
              title: 'wm_no',
              required: 'O',
              type: 'Number(8)',
              desc: '메모등록자',
              indent: 2,
            },
            {
              title: 'content',
              required: 'O',
              type: 'String(65535)',
              desc: '메모내용',
              indent: 2,
            },
            {
              title: 'total',
              required: 'O',
              type: 'Number',
              desc: '검색된 세트상품 수',
            },
          ],
          response_example: {
            results: [
              {
                set_no: 23149,
                sol_no: 640,
                depot_no: 746,
                wdate: '2021-03-23 11:34:55',
                mdate: '2021-03-23 11:34:55',
                set_cd: 'SETDAFEA-BLS-FFATAD-ADF5-4',
                model_no: 'SETA.12340',
                set_status: '정상',
                set_name: '테스트 세트',
                set_img: '',
                sale_price: 40000,
                use_sale_cnt_limit_yn: 0,
                sale_cnt_limit: null,
                main_prod_no: 5515759,
                main_sku_cd: 'S2321B1D9CF9',
                delivery_vendor_name: '로니 배송처',
                set_prod_cnt: 3,
                set_sku_cds: 'S2321B1D9CF9,S109CFEF4160,S1107CB504E4',
                set_pack_units: '1,1,1',
                set_cost_prices: '0,0,0',
                set_supply_prices: '0,0,0',
                link_yn: 0,
                link_ord_yn: 0,
                memo: [
                  {
                    set_no: 23149,
                    memo_no: 2313832,
                    wdate: '2021-03-23 11:41:29',
                    mdate: '2021-03-23 11:41:29',
                    memo_Status: '등록',
                    wm_no: 1957,
                    content: '메모 해봅니다.',
                  },
                ],
              },
              {
                set_no: 23148,
                sol_no: 640,
                depot_no: 775,
                wdate: '2021-03-23 11:34:07',
                mdate: '2021-03-23 11:34:07',
                set_cd: 'SETFDDFA-BSF-FFATAD-ADF5-6',
                model_no: null,
                set_status: '정상',
                set_name: '캐주얼 패딩',
                set_img: '',
                sale_price: 90000,
                use_sale_cnt_limit_yn: 1,
                sale_cnt_limit: 10,
                main_prod_no: 4598998,
                main_sku_cd: 'S2891CCA5D16',
                delivery_vendor_name: '로니 배송처',
                set_prod_cnt: 5,
                set_sku_cds:
                  'S2891CCA5D16,S8065D991761,S226F05C48B3,S9000CBBD792,S1415CA419AA',
                set_pack_units: '1,1,1,1,1',
                set_cost_prices: '0,0,0,0,0',
                set_supply_prices: '0,0,0,0,0',
                link_yn: 0,
                link_ord_yn: 0,
                memo: [],
              },
            ],
            total: 2,
          },
        },
      ],
    },
    {
      title: '세트상품 등록',
      url: '/doc/세트상품 등록',
      data: [
        {
          version: 'v1.0',
          url: '/stock/set-add',
          desc: apiDocDesc({
            items: [
              '세트상품 정보를 등록합니다.',
              '배송처가 동일하며, 합포장이 가능한 SKU상품으로 세트를 구성할 수 있습니다.',
              'setProdList는 필수 입력 항목입니다.',
            ],
          }),
          method: 'POST',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'set_cd',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '세트코드',
                notes: [
                  '세트코드는 영문/숫자/특수문자 ( ) - _ = + , . / 만 입력이 가능합니다.',
                  '세트코드 자동생성을 원하시는경우 \'AUTO\' 로 하십시오.',
                ],
              }),
            },
            {
              title: 'set_name',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '세트 상품명', sub: '세트 상품명은 한글, 영문, 숫자 최대 200Byte 까지만 등록가능합니다.' }),
            },
            {
              title: 'depot_no',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({
                title: '배송처코드',
                notes: ['세트로 구성한 SKU상품의 배송처코드를 입력합니다.', '배송처가 다른 상품은 세트 상품으로 구성될 수 없습니다.'],
              }),
            },
            {
              title: 'sale_price',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '세트 판매가', sub: '세트 상품의 판매가를 관리하지 않을 경우 생략 가능합니다.' }),
            },
            {
              title: 'out_leadtime',
              required: '',
              type: 'Number',
              desc: '출고 리드타임',
            },
            {
              title: 'sale_cnt_type',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '세트 판매수량 제한 사용여부', defaultValue: 'false' }),
            },
            {
              title: 'sale_cnt_limit',
              required: '△',
              type: 'Number',
              desc: apiParamDesc({
                title: '세트 판매수량',
                notes: ['세트 판매수량 제한 사용시 필수입니다.', '판매수량 값은 \'0\' 이상 입력되어야 합니다.'],
              }),
            },
            {
              title: 'set_img',
              required: '',
              type: 'String',
              desc: '세트 대표 이미지 URL',
            },
            {
              title: 'setProdList',
              required: 'O',
              type: 'Object[]',
              desc: 'SKU상품 리스트',
            },
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String',
              desc: 'SKU코드',
              indent: 1,
            },
            {
              title: 'pack_unit',
              required: 'O',
              type: 'Number(10)',
              desc: apiParamDesc({
                title: 'SKU상품 출고수량',
                notes: [
                  '주문 수량 1개당 출고되는 해당 SKU상품의 수량을 입력합니다.',
                  '단품으로 구성된 세트상품의 경우에는 최소 \'2\'이상 입력되어야 합니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'set_cost_price',
              required: '',
              type: 'Number(10)',
              desc: apiParamDesc({ title: 'SKU상품의 세트원가', sub: '(세트로 구성시 원가가 달라지는 경우에만 입력합니다.)' }),
              indent: 1,
            },
            {
              title: 'set_supply_price',
              required: '',
              type: 'Number(10)',
              desc: apiParamDesc({ title: 'SKU상품의 세트공급가', sub: '(세트로 구성시 공급가가 달라지는 경우에만 입력합니다.)' }),
              indent: 1,
            },
            ...(userInfo.sol_ser?.includes('cal_state_per_prod') ? [
              {
                title: 'set_sales_per',
                required: '',
                type: 'Number(10)',
                desc: apiParamDesc({
                  title: '세트상품 금액비중',
                  notes: [
                    '금액비중은 정수로만 입력 가능합니다. (소수점 입력불가)',
                    '필수 입력사항은 아니지만, 세트상품 내 1개 이상 설정시 전체 금액 비중의 합은 100%가 되어야 합니다.',
                  ],
                }),
                indent: 1,
              }
            ] : []),
            {
              title: 'main_sku_cd',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '대표 SKU코드',
                notes: ['세트로 구성된 상품 중 대표 상품의 SKU코드를 입력합니다.', '대표상품을 지정하지 않을 경우, 첫번째 상품이 자동 지정됩니다.'],
              }),
            },
          ],
          body_example: {
            set_cd: 'AUTO',
            set_name: '세트 상품명',
            depot_no: 5235,
            sale_cnt_type: false,
            set_img: 'http://sample.playauto.io/sample.png',
            setProdList: [
              {
                sku_cd: 'S55517D306C6',
                pack_unit: 2,
              },
              {
                sku_cd: 'S3933B08F3C5',
                pack_unit: 1,
              },
              {
                sku_cd: 'S3045CF1E2EF',
                pack_unit: 1,
              },
            ],
          },
          response: [
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: '등록 결과 (성공, 실패)',
            },
            {
              title: 'set_cd',
              required: 'O',
              type: 'String',
              desc: '세트 코드',
            },
            {
              title: 'set_no',
              required: 'O',
              type: 'Number',
              desc: '세트상품 고유 키',
            },
            {
              title: 'messages',
              required: 'O',
              type: 'String[]',
              desc: '등록이 실패된경우 에러 메세지',
            },
          ],
          response_example: {
            set_no: 409823,
            set_cd: 'T382E95701EA',
            result: '성공',
          },          
        },
      ],
    },
    {
      title: '세트상품 수정',
      url: '/doc/세트상품 수정',
      data: [
        {
          version: 'v1.0',
          url: '/stock/set-edit',
          desc: apiDocDesc({
            items: [
              '세트상품 정보를 수정합니다.',
              '수정을 원하지 않는 항목은 항목자체를 삭제 후 호출합니다.',
              'SKU상품 항목 변경시엔 전체 SKU상품 구성을 입력해주셔야 합니다.',
            ],
          }),
          method: 'PUT',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'set_cd',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '세트코드' }),
            },
            {
              title: 'set_name',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '세트 상품명', sub: '세트 상품명은 한글, 영문, 숫자 최대 200Byte 까지만 등록가능합니다.' }),
            },
            {
              title: 'depot_no',
              required: '△',
              type: 'Number',
              desc: apiParamDesc({
                title: '배송처코드',
                notes: ['세트로 구성한 SKU상품의 배송처코드를 입력합니다.', 'SKU상품 구성에 변경사항이 있을 경우 필수로 입력되어야 합니다.'],
              }),
            },
            {
              title: 'sale_price',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '세트 판매가', sub: '세트 상품의 판매가를 관리하지 않을 경우 생략 가능합니다.' }),
            },
            {
              title: 'sale_cnt_type',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '세트 판매수량 제한 사용여부', defaultValue: 'false' }),
            },
            {
              title: 'sale_cnt_limit',
              required: '△',
              type: 'Number',
              desc: apiParamDesc({
                title: '세트 판매수량',
                notes: ['세트 판매수량 제한 사용시 필수입니다.', '판매수량 값은 \'0\' 이상 입력되어야 합니다.'],
              }),
            },
            {
              title: 'set_img',
              required: '',
              type: 'String',
              desc: '세트 대표 이미지 URL',
            },
            {
              title: 'setProdList',
              required: '',
              type: 'Object[]',
              desc: 'SKU상품 리스트',
            },
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String',
              desc: 'SKU코드',
              indent: 1,
            },
            {
              title: 'pack_unit',
              required: 'O',
              type: 'Number(10)',
              desc: apiParamDesc({
                title: 'SKU상품 출고수량',
                notes: [
                  '주문 수량 1개당 출고되는 해당 SKU상품의 수량을 입력합니다.',
                  '단품으로 구성된 세트상품의 경우에는 최소 \'2\'이상 입력되어야 합니다.',
                ],
              }),
              indent: 1,
            },
            {
              title: 'set_cost_price',
              required: '',
              type: 'Number(10)',
              desc: apiParamDesc({ title: 'SKU상품의 세트원가', sub: '(세트로 구성시 원가가 달라지는 경우에만 입력합니다.)' }),
              indent: 1,
            },
            {
              title: 'set_supply_price',
              required: '',
              type: 'Number(10)',
              desc: apiParamDesc({ title: 'SKU상품의 세트공급가', sub: '(세트로 구성시 공급가가 달라지는 경우에만 입력합니다.)' }),
              indent: 1,
            },
            ...(userInfo.sol_ser?.includes('cal_state_per_prod') ? [
              {
                title: 'set_sales_per',
                required: '',
                type: 'Number(10)',
                desc: apiParamDesc({
                  title: '세트상품 금액비중',
                  notes: [
                    '금액비중은 정수로만 입력 가능합니다. (소수점 입력불가)',
                    '필수 입력사항은 아니지만, 세트상품 내 1개 이상 설정시 전체 금액 비중의 합은 100%가 되어야 합니다.',
                  ],
                }),
                indent: 1,
              }
            ] : []),
            {
              title: 'main_sku_cd',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '대표 SKU코드',
                notes: ['세트로 구성된 상품 중 대표 상품의 SKU코드를 입력합니다.', '대표상품을 지정하지 않을 경우, 첫번째 상품이 자동 지정됩니다.'],
              }),
            },
          ],
          body_example: {
            set_cd: 'T382E95701EA',
            depot_no: 5235,
            setProdList: [
              {
                sku_cd: 'S55517D306C6',
                pack_unit: 2,
              },
              {
                sku_cd: 'S3933B08F3C5',
                pack_unit: 2,
              },
              {
                sku_cd: 'S3045CF1E2EF',
                pack_unit: 1,
              },
            ],
          },
          response: [
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: '등록 결과 (성공, 실패)',
            },
            {
              title: 'set_cd',
              required: 'O',
              type: 'String',
              desc: '세트 코드',
            },
            {
              title: 'messages',
              required: 'O',
              type: 'String[]',
              desc: '등록이 실패된경우 에러 메세지',
            },
          ],
          response_example: {
            set_cd: 'T382E95701EA',
            result: '성공',
          },
        },
      ],
    },
    {
      title: '재고수정',
      url: '/doc/재고수정',
      data: [
        {
          version: 'v1.0',
          url: '/stock/manage',
          method: 'PUT',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'sku_cds',
              required: 'O',
              type: 'Object[]',
              desc: '재고를 출고, 또는 입고시킬 sku 리스트를 입력합니다.',
            },
            {
              title: 'set',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '재고를 변경할 대상을 설정합니다.',
                sub: '안전재고로 설정시 입력한 수량이 입,출고되는게 아닌 입력한 수량으로 안전재고값이 업데이트됩니다.',
                allowedValues: ['실재고', '안전재고'],
              }),
            },
            {
              title: 'type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '재고적용 방식을 설정합니다.',
                sub: '실재고 입력시 필수입니다..',
                allowedValues: ['출고', '입고'],
              }),
            },
            {
              title: 'count',
              required: 'O',
              type: 'Number',
              desc: '변경할 재고수량을 입력합니다.',
            },
          ],
          body_example: {
            sku_cds: ['S999C90F18A4'],
            set: '실재고',
            type: '입고',
            count: 20,
          },
          response: [
            {
              title: 'sku_cds',
              required: 'O',
              type: 'String[]',
              desc: '호출된 sku 정보',
            },
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: '성공,실패여부',
            },
            {
              title: 'stockAlarm',
              required: 'O',
              type: 'Object[]',
              desc: '품절 및 재고부족 상품정보',
            },
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String',
              desc: '품절 및 재고부족 상품의 SKU코드',
              indent: 1,
            },
            {
              title: 'stock_status',
              required: 'O',
              type: 'String',
              desc: '품절 또는 재고부족 상태',
              indent: 1,
            },
          ],
          response_example: {
            sku_cds: ['S999C90F18A4'],
            result: '성공',
            stockAlarm: [
              {
                sku_cd: 'S999C90F18A4',
                stock_status: '재고 부족',
              },
            ],
          },
        },
      ],
    },
    {
      title: '재고현황조회',
      url: '/doc/재고현황조회',
      data: [
        {
          version: 'v1.0',
          url: '/stock/condition',
          method: 'POST',
          desc: apiDocDesc({ items: ['재고 현황을 조회합니다.', '기본 날짜 검색일을 90일 입니다.'] }),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'start',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '조회할 시작 카운트', defaultValue: '0' }),
            },
            {
              title: 'limit',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '조회할 갯수', defaultValue: '100' }),
            },
            {
              title: 'orderbyType',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '정렬타입', defaultValue: 'DESC', allowedValues: ['ASC', 'DESC'] }),
            },
            {
              title: 'orderbyColumn',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '정렬대상',
                defaultValue: 'wdate',
                allowedValues: [
                  ['wdate', '<strong>등록일</strong>'],
                  ['sku_cd', '<strong>SKU코드</strong>'],
                  ['stock_cd', '<strong>재고관리코드</strong>'],
                  ['stock_status', '<strong>재고상태</strong>'],
                  ['stock_cnt_real', '<strong>실재고</strong>'],
                  ['stock_cnt_safe', '<strong>안전재고</strong>'],
                ],
              }),
            },
            {
              title: 'search_key',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색 키',
                allowedValues: [
                  ['sku_cd', '<strong>SKU코드</strong>'],
                  ['stock_cd', '<strong>재고관리코드</strong>'],
                  ['prod_name', '<strong>SKU상품명</strong>'],
                ],
                notes: ['<code>값을 넣지않는경우 전체검색됩니다.</code>'],
              }),
            },
            {
              title: 'search_word',
              required: '',
              type: 'String',
              desc: '검색어',
            },
            {
              title: 'search_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색타입',
                defaultValue: 'partial',
                allowedValues: [['exact', '<strong>완전일치</strong>'], ['partial', '<strong>부분일치</strong>']],
              }),
            },
            {
              title: 'date_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '날짜검색대상',
                defaultValue: 'wdate',
                allowedValues: [['wdate', '<strong>등록일</strong>'], ['mdate', '<strong>수정일</strong>']],
              }),
            },
            {
              title: 'sdate',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색시작일',
                sub: '( YYYY-MM-DD | YYYY-MM-DD HH:MM:SS )<br />미입력시 기본 90일로 조회됩니다.',
              }),
            },
            {
              title: 'edate',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '검색종료일', sub: '( YYYY-MM-DD | YYYY-MM-DD HH:MM:SS )' }),
            },
            {
              title: 'supp_no',
              required: '',
              type: 'Number',
              desc: '매입처 번호',
            },
            {
              title: 'depot_no',
              required: '',
              type: 'Number',
              desc: '배송처 번호',
            },
            {
              title: 'state',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '재고상태', allowedValues: ['정상', '재고부족', '품절'] }),
            },
            ...(userInfo.sol_no === 104083 ? [{
              title: 'sub_sol_no_list',
              required: '',
              type: 'Number[]',
              desc: apiParamDesc({ title: '하위계정 sol_no 리스트', sub: '(값이 없는 경우 하위계정 전체 조회)' }),
            }] : []),
          ],
          body_example: {
            start: 0,
            limit: 100,
            orderbyColumn: 'wdate',
            orderbyType: 'DESC',
            search_key: 'all',
            search_word: '',
            search_type: 'partial',
            date_type: 'wdate',
            sdate: '2020-12-25',
            edate: '2021-01-25',
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Array',
              desc: '결과',
            },
            {
              title: 'sol_no',
              required: 'O',
              type: 'Number(8)',
              desc: '솔루션번호',
              indent: 1,
            },
            {
              title: 'prod_no',
              required: 'O',
              type: 'Number(10)',
              desc: 'SKU상품고유번호',
              indent: 1,
            },
            {
              title: 'depot_no',
              required: 'O',
              type: 'Number(8)',
              desc: '배송처번호',
              indent: 1,
            },
            {
              title: 'depot_name',
              required: 'O',
              type: 'String(45)',
              desc: '배송처이름',
              indent: 1,
            },
            {
              title: 'stock_status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '재고상태', allowedValues: ['정상', '재고부족', '품절'] }),
              indent: 1,
            },
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String(40)',
              desc: 'SKU코드',
              indent: 1,
            },
            {
              title: 'prod_img',
              required: 'O',
              type: 'String(255)',
              desc: '이미지',
              indent: 1,
            },
            {
              title: 'prod_name',
              required: 'O',
              type: 'String(200)',
              desc: 'SKU상품명',
              indent: 1,
            },
            {
              title: 'brand',
              required: 'O',
              type: 'String(50)',
              desc: '브랜드',
              indent: 1,
            },
            {
              title: 'maker',
              required: 'O',
              type: 'Sting(50)',
              desc: '제조사',
              indent: 1,
            },
            {
              title: 'barcode',
              required: 'O',
              type: 'String(50)',
              desc: '바코드',
              indent: 1,
            },
            {
              title: 'made_date',
              required: 'O',
              type: 'String(10)',
              desc: '제조일자',
              indent: 1,
            },
            {
              title: 'expire_date',
              required: 'O',
              type: 'String(10)',
              desc: '유효일자',
              indent: 1,
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String(19)',
              desc: 'SKU상품 등록일',
              indent: 1,
            },
            {
              title: 'sale_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({ title: '판매가', sub: '(data type: Decimal(12,2))' }),
              indent: 1,
            },
            {
              title: 'cost_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({ title: '원가', sub: '(data type: Decimal(12,2))' }),
              indent: 1,
            },
            {
              title: 'supply_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({ title: '공급가', sub: '(data type: Decimal(12,2))' }),
              indent: 1,
            },
            {
              title: 'supp_name',
              required: 'O',
              type: 'String(50)',
              desc: '매입처',
              indent: 1,
            },
            {
              title: 'attri',
              required: 'O',
              type: 'String(150)',
              desc: '옵션',
              indent: 1,
            },
            {
              title: 'stock_cnt_real',
              required: 'O',
              type: 'Number(8)',
              desc: '실재고',
              indent: 1,
            },
            {
              title: 'stock_cnt',
              required: 'O',
              type: 'Number(8)',
              desc: '판매가능재고',
              indent: 1,
            },
            {
              title: 'in_cnt_accum',
              required: 'O',
              type: 'Number(10)',
              desc: '입고수량',
              indent: 1,
            },
            {
              title: 'out_cnt_accum',
              required: 'O',
              type: 'Number(10)',
              desc: '출고수량',
              indent: 1,
            },
            {
              title: 'out_scheduled',
              required: 'O',
              type: 'Number(10)',
              desc: '출고예정수',
              indent: 1,
            },
            {
              title: 'sale_cnt_accum',
              required: 'O',
              type: 'Number(10)',
              desc: '구매수량',
              indent: 1,
            },
            {
              title: 'return_cnt_accum',
              required: 'O',
              type: 'Number(10)',
              desc: '반품수량',
              indent: 1,
            },
            {
              title: 'exchange_cnt_accum',
              required: 'O',
              type: 'Number(10)',
              desc: '교환수량',
              indent: 1,
            },
            {
              title: 'unavail_out_cnt',
              required: 'O',
              type: 'Number(10)',
              desc: '미출고',
              indent: 1,
            },
            {
              title: 'link_yn',
              required: 'O',
              type: 'Number(1)',
              desc: apiParamDesc({ title: '연동상품여부', sub: '(1: 연동상품 있음, 0: 연동상품 없음)' }),
              indent: 1,
            },
            {
              title: 'link_set_yn',
              required: 'O',
              type: 'Number(1)',
              desc: apiParamDesc({ title: '연동세트상품여부', sub: '(1: 연동세트상품 있음, 0: 연동세트상품 없음)' }),
              indent: 1,
            },
            {
              title: 'link_ord_yn',
              required: 'O',
              type: 'Number(1)',
              desc: apiParamDesc({ title: '연동주문여부', sub: '(1: 연동주문 있음, 0: 연동주문 없음)' }),
              indent: 1,
            },
            {
              title: 'memo_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '메모여부',
              indent: 1,
            },
            {
              title: 'memo_complete_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '완료메모여부',
              indent: 1,
            },
            {
              title: 'alloc_rule_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '재고할당여부',
              indent: 1,
            },
            {
              title: 'realloc_rule_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '재고 재할당여부',
              indent: 1,
            },
            {
              title: 'recordsTotal',
              required: 'O',
              type: 'Number',
              desc: '총 카운트',
            },
            {
              title: 'all_stock',
              required: 'O',
              type: 'Number',
              desc: '조회된 모든 상태의 SKU상품 수',
            },
            {
              title: 'ok_stock',
              required: 'O',
              type: 'Number',
              desc: '정상상태 SKU상품 수',
            },
            {
              title: 'real_stock_none',
              required: 'O',
              type: 'Number',
              desc: '재고부족 SKU상품 수',
            },
            {
              title: 'safe_stock_alert',
              required: 'O',
              type: 'Number',
              desc: '품절 SKU상품 수',
            },
          ],
          response_example: {
            results: [
              {
                sol_no: 9999999,
                prod_no: 5945137,
                depot_no: 2998,
                depot_name: 'TEST 배송처',
                stock_status: '정상',
                sku_cd: 'S244E0FF7456',
                stock_cd: '',
                prod_img: '',
                prod_name: 'TEST SKU상품',
                brand: '',
                maker: '',
                barcode: '',
                made_date: null,
                expire_date: null,
                wdate: '2020-12-28 12:00:36',
                sale_price: 0,
                cost_price: 0,
                supply_price: 0,
                supp_name: null,
                attri: "'ㅁ'",
                stock_cnt_real: 100,
                stock_cnt: 100,
                stock_cnt_safe: 25,
                in_cnt_accum: 100,
                out_cnt_accum: 0,
                out_scheduled: 0,
                sale_cnt_accum: 0,
                return_cnt_accum: 0,
                exchange_cnt_accum: 0,
                unavail_out_cnt: 0,
                link_yn: 0,
                link_set_yn: 0,
                link_ord_yn: 0,
                memo_yn: 0,
                memo_complete_yn: 0,
                alloc_rule_yn: 0,
                realloc_rule_yn: 0,
              },
            ],
            recordsTotal: 1,
            all_stock: 1,
            ok_stock: 1,
            real_stock_none: 0,
            safe_stock_alert: 0,
          },
        },
      ],
    },
    {
      title: '입출고내역조회',
      url: '/doc/입출고내역조회',
      data: [
        {
          version: 'v1.0',
          url: '/stock/inout',
          method: 'POST',
          desc: apiDocDesc({ items: ['최대 3개월 이내 입출고 내역을 조회합니다.', '정렬 순서는 최신순으로 조회됩니다.'] }),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'start',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '조회할 시작 카운트', defaultValue: '0' }),
            },
            {
              title: 'length',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '조회할 입출고 내역 개수',
                sub: '최대 500건 단위로 검색 가능합니다.',
                maxValue: '500',
                defaultValue: '100',
              }),
            },
            {
              title: 'search_key',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색 키',
                allowedValues: [
                  ['sku_cd', '<strong>SKU코드</strong>'],
                  ['stock_cd', '<strong>재고관리코드</strong>'],
                  ['prod_name', '<strong>SKU상품명</strong>'],
                ],
                notes: ['<code>값을 넣지않는경우 전체검색됩니다.</code>'],
              }),
            },
            {
              title: 'search_word',
              required: '',
              type: 'String',
              desc: '검색어',
            },
            {
              title: 'search_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색타입',
                defaultValue: 'partial',
                allowedValues: [['exact', '<strong>완전일치</strong>'], ['partial', '<strong>부분일치</strong>']],
              }),
            },
            {
              title: 'sdate',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색시작일',
                sub: '( YYYY-MM-DD | YYYY-MM-DD HH:MM:SS )<br />미입력시 기본 90일로 조회됩니다.<strong>검색은 최대 3개월 이내로만 가능합니다.</strong>',
              }),
            },
            {
              title: 'edate',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '검색종료일', sub: '( YYYY-MM-DD | YYYY-MM-DD HH:MM:SS )' }),
            },
            {
              title: 'inout_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '재고상태',
                allowedValues: [
                  ['in', '<strong>입고</strong>'],
                  ['out', '<strong>출고</strong>'],
                  ['transfer', '<strong>재고이동</strong>'],
                  ['notsale', '<strong>판매불가</strong>'],
                ],
              }),
            }
          ],
          body_example: {
            "search_key":"",
            "search_word":"",
            "search_type":"partial",
            "date_type":"wdate",
            "inout_type": "",
            "sdate" : "2026-04-13",
            "edate" : "2026-04-13"
          },
          response: [
            {
              title: 'results',
              required: '',
              type: 'Array',
              desc: '결과',
            },
            {
              title: 'prod_no',
              required: '',
              type: 'Number(10)',
              desc: 'SKU상품고유번호',
              indent: 1,
            },
            {
              title: 'wdate',
              required: '',
              type: 'String(19)',
              desc: '입출고일시',
              indent: 1,
            },
            {
              title: 'inout_type',
              required: '',
              type: 'String',
              desc: '입출고타입',
              indent: 1,
            },
            {
              title: 'sku_cd',
              required: '',
              type: 'String(40)',
              desc: 'SKU코드',
              indent: 1,
            },
            {
              title: 'prod_name',
              required: '',
              type: 'String(200)',
              desc: 'SKU상품명',
              indent: 1,
            },
            {
              title: 'attri',
              required: '',
              type: 'String(150)',
              desc: '옵션',
              indent: 1,
            },
            {
              title: 'work_name',
              required: '',
              type: 'String',
              desc: '작업명',
              indent: 1,
            },
            {
              title: 'depot_name',
              required: '',
              type: 'String(45)',
              desc: '배송처이름',
              indent: 1,
            },
            {
              title: 'in_cnt',
              required: '',
              type: 'Number',
              desc: '입고 수량',
              indent: 1,
            },
            {
              title: 'out_cnt',
              required: '',
              type: 'Number',
              desc: '출고 수량',
              indent: 1,
            },
            {
              title: 'move_cnt',
              required: '',
              type: 'Number',
              desc: '재고이동 수량',
              indent: 1,
            },
            {
              title: 'notsale_type_cnt',
              required: '',
              type: 'Number',
              desc: '판매불가 수량',
              indent: 1,
            },
            {
              title: 'stock_cnt_real',
              required: '',
              type: 'Number(8)',
              desc: '실재고',
              indent: 1,
            },
            {
              title: 'maker',
              required: '',
              type: 'String(50)',
              desc: '제조사',
              indent: 1,
            },
            {
              title: 'brand',
              required: '',
              type: 'String(50)',
              desc: '브랜드',
              indent: 1,
            },
            {
              title: 'barcode',
              required: '',
              type: 'String(50)',
              desc: '바코드',
              indent: 1,
            },
            {
              title: 'stock_cd',
              required: '',
              type: 'String',
              desc: '재고관리코드',
              indent: 1,
            },
            {
              title: 'content',
              required: '',
              type: 'String',
              desc: '사유',
              indent: 1,
            },
            {
              title: 'recordsTotal',
              required: '',
              type: 'Number',
              desc: '총 카운트',
            }
          ],
          response_example: {
            results: [
                {
                    prod_no: 12345678,
                    wdate: "2026-04-13 00:00:00",
                    inout_type: "판매불가",
                    sku_cd: "318287",
                    prod_name: "TEST상품",
                    attri: "",
                    work_name: "리스트에서 판매불가 처리",
                    depot_name: "배송처테스트",
                    in_cnt: 0,
                    out_cnt: 0,
                    move_cnt: 0,
                    notsale_type_cnt: 3,
                    stock_cnt_real: 3,
                    maker: "",
                    brand: "",
                    barcode: "",
                    stock_cd: "",
                    content: "3"
                }
            ],
            recordsTotal: 1
          },
        },
      ],
    },
  ];
};

export default getV10APIs;